module.exports = __webpack_public_path__ + "img/send_button_on.94dc2302.png";